export default "/images/vendor/flag-icon-css/flags/4x3/hn.svg?519dcaf5e34eb209bc595d1c07c0dc27";